import { render, staticRenderFns } from "./EmailEditor.vue?vue&type=template&id=78f18531&scoped=true"
import script from "./EmailEditor.vue?vue&type=script&lang=js"
export * from "./EmailEditor.vue?vue&type=script&lang=js"
import style0 from "./EmailEditor.vue?vue&type=style&index=0&id=78f18531&prod&lang=css"
import style1 from "./EmailEditor.vue?vue&type=style&index=1&id=78f18531&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f18531",
  null
  
)

export default component.exports